import React, { useContext, useEffect,useState } from "react";
import moment from "moment-timezone";
import { ShiftService } from "../api/ShiftService";
import { ShiftProps } from "../interfacesProps/ShiftProps";
import {
  Colors,
  Spacing,
  FontSize,
} from "../theme/Theme";
import {
  RenderTextWithTitle,
  renderTextWithTitleAndChildComponent,
  detailTextStyle,
  titleHeaderTextStyle,
} from "../components/TextWithHeader";
import { ColumnStyle } from "../theme/ComponentTheme";
import { RBContext } from "../components/RBContext";
import { defaultAllowOffersIcon } from "../components/RBShiftRelatedIcons";
import { findUserShiftRequest } from "../util/ShiftToRequest";
import { findApplicantUserRequest } from "../util/ShiftToRequest";

interface Props {
    applicant?: any;
    shiftId?: string;   
  shiftData: ShiftProps;
  account?: any;
  
}

export const OriginalShiftDetails: React.FC<Props> = ({ applicant, shiftId,shiftData, account }) => {
  const { secondaryColor } = useContext(RBContext);

    const [userRequest, setUserRequest] = useState<any>(null);

   useEffect(() => {
      if (applicant && shiftId) {
        const matchedRequest = findApplicantUserRequest(applicant, shiftId);
        
        setUserRequest(matchedRequest);
      }
    }, [applicant, shiftId]);
      if (!shiftData) return null;

//   const userRequest = findUserShiftRequest(shiftData, account?.id);
  const startOriginal = moment(shiftData.officialStartTime).tz(shiftData.shiftTimeZone);
  const endOriginal = moment(shiftData.officialEndTime).tz(shiftData.shiftTimeZone);
  const dateStringOriginal = startOriginal.format("ddd, MMM Do YYYY");
  const startTimeFormatOriginal = startOriginal ? startOriginal.format("h:mm a") : "N/A";
  const endTimeFormatOriginal = endOriginal ? endOriginal.format("h:mm a") : "N/A";
  const hoursDisplayOriginal = ShiftService.getShiftOfficialLengthDisplay(shiftData);

  // determine effective original wage (prefer userRequest.originalWage if present)
  const effectiveShiftWageOriginal = (userRequest && userRequest.originalWage != null)
    ? userRequest.originalWage
    : shiftData.wage || 0;

  const allowOffers = shiftData.allowOffers;

  // compute displayed wage / worker fee for original values
  let workerFeeOriginalDisplay = "";
  let wageOriginalDisplay = "";

  if (shiftData.actualCommission) {
    const workerFeeOriginal = (effectiveShiftWageOriginal / 100).toFixed(2);
    const wageOriginal = ((effectiveShiftWageOriginal / 100) + ShiftService.getPlacementFee(shiftData)).toFixed(2);
    workerFeeOriginalDisplay = workerFeeOriginal;
    wageOriginalDisplay = wageOriginal;
  } else {
    // if not actualCommission show wage that owners/workers see (use ShiftService helpers)
    const wageVal = (ShiftService.getWage(shiftData, account) ?? shiftData.wage) / 100;
    const workerFeeVal = shiftData.actualCommission ? wageVal : wageVal; // fallback
    workerFeeOriginalDisplay = workerFeeVal.toFixed(2);
    wageOriginalDisplay = workerFeeOriginalDisplay;
  }

  return (
    <>
      <div
        style={{
          height: 1,
          backgroundColor: Colors.defaultGrey,
          marginTop: Spacing.medium,
          marginBottom: Spacing.medium,
        }}
      />
      <div className={"section-header-text"} style={{ marginBottom: 16, fontSize: FontSize.largest }}>
        Original Shift Details
      </div>

      <div style={ColumnStyle}>
        {renderTextWithTitleAndChildComponent(
          "Start Time",
          <div style={{ ...detailTextStyle }}>{startOriginal ? <span style={{ color: "rgb(52, 175, 71)", fontWeight: "bold" }}>{startOriginal.format("ddd, MMM Do YYYY h:mm a")}</span> : <span style={{ color: Colors.defaultGrey }}>N/A</span>}</div>
        )}
        {renderTextWithTitleAndChildComponent(
          "End Time",
          <div style={{ ...detailTextStyle }}>{endOriginal ? <span style={{ color: "rgb(52, 175, 71)", fontWeight: "bold" }}>{endOriginal.format("ddd, MMM Do YYYY h:mm a")}</span> : <span style={{ color: Colors.defaultGrey }}>N/A</span>}</div>
        )}
        
     </div>
     <div style={ColumnStyle}>

      {renderTextWithTitleAndChildComponent(
          "Duration",
          <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)" }}>{hoursDisplayOriginal}</div>
        )}
        <>
          {(shiftData.disputeResolution === "pharmacy" && shiftData.disputeUnpaidBreakMinutes) ?
            RenderTextWithTitle("Unpaid Breaks (Min)", shiftData.disputeUnpaidBreakMinutes + " mins") :
            ((shiftData.disputeResolution === "pharmacist" || shiftData.disputeResolution === null) && shiftData.unpaidBreakMinutes) ?
              RenderTextWithTitle("Unpaid Breaks (Min)", shiftData.unpaidBreakMinutes + " mins") :
              (<div style={{ flex: 1, alignItems: "flex-start" }}>
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    ...titleHeaderTextStyle,
                  }}
                >
                  <div style={{ marginLeft: Spacing.smallest }}>Hourly Rate</div>
                </div>

                <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)" }}>
                  {"$" + (shiftData.actualCommission ? workerFeeOriginalDisplay : wageOriginalDisplay)}
                </div>
              </div>)
          }
        </>
      </div>

      {((shiftData.disputeResolution === "pharmacy" && shiftData.disputeUnpaidBreakMinutes) ||
        ((shiftData.disputeResolution === "pharmacist" || shiftData.disputeResolution === null) && shiftData.unpaidBreakMinutes !== null)) && (
        <div style={ColumnStyle}>
          <div style={{ flex: 1, alignItems: "flex-start" }}>
            <div
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                ...titleHeaderTextStyle,
              }}
            >
              <div style={{ marginLeft: Spacing.smallest }}>Hourly Rate</div>
            </div>

            <div style={{ ...detailTextStyle, color: "rgb(52, 175, 71)" }}>
              {"$" + (shiftData.actualCommission ? workerFeeOriginalDisplay : wageOriginalDisplay)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OriginalShiftDetails;